/**
 * Event dynamic form viewer component
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { get, cloneDeep, isEqual } from 'lodash';
import {IEvent, IEventDefinition} from '../../../Interfaces/index';
import moment from "moment";
import {InterpolateService} from "@ispm/shared/services/interpolate.service";

@Component({
  selector: 'ispm-event-dynamic-form-viewer',
  templateUrl: './event.dynamic-form-viewer.component.html',
  styleUrls: ['./event.dynamic-form-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventDynamicFormViewerComponent implements OnInit {
  load: boolean = true;
  public reValidateMessage = '';
  public validationArray: [boolean, boolean] = [null, null];
  @Input() selectedEvent: IEvent;
  @Input() isEditable: boolean = false;
  @Input() eventDefinition: IEventDefinition;
  @Input() set eventFormData(_formData: Array<any>) {
    this._eventFormData = _formData;
    this.changeDetector.markForCheck();
    this.changeDetector.detectChanges();
  }

  @Input() set eventFormConfigs(_configs: Array<string>) {
    this._eventFormConfigs = _configs;
    this.configCss = get(this._eventFormConfigs[0],'cssClass','');
    this.payload = [];
    if (this._eventFormConfigs) {
      for (const formConfig of this._eventFormConfigs) {
        this.payload.push(
          {
            data: { },
            contentType: get(formConfig, 'key') === 'links' ? 'link' : 'form',
            formKey: get(formConfig, 'key'),
            updatedFields: []
          });
      }
      this.changeDetector.markForCheck();
      this.changeDetector.detectChanges();
    }
  }

  _eventFormConfigs: Array<any>;
  _eventFormData: Array<any>;
  configCss:string;
  public valid: boolean;
  public submitted: boolean = false;
  public hasUpdatedFields: boolean;
  public payload: any;
  @Output() onFormDataUpdated: EventEmitter<any> = new EventEmitter();

  constructor(private changeDetector: ChangeDetectorRef,
              private interpolateService: InterpolateService) {
}

  ngOnInit() {
  }

  /**
   * Update form data
   * @param formData
   * @param index
   */
  updateFormData(formData, index) {
    if (formData.updated) {
      if (isEqual(JSON.stringify(this.payload[index]), JSON.stringify(formData.form))) {
        return;
      }
      this.hasUpdatedFields = true;
      this.payload[index].data = formData.form;
      this.payload[index].updatedFields = this.payload[index].updatedFields.concat(formData.updated);
      this.onFormDataUpdated.emit({ payload: cloneDeep(this.payload), hasUpdatedFields: this.hasUpdatedFields});
    }
  }

  showValidateEvent() {
    if(!get(this.selectedEvent,'approved') && get(this.selectedEvent,'isExternalUpdate') && get(this.eventDefinition,'ui.reValidateNotification.display',true)) {
      this.reValidateMessage = this.getRevalidateMessage();
      return true;
    }else {
      return false;
    }
  }

  private getRevalidateMessage() {
    let text = '';
    if(get(this.eventDefinition,'ui.reValidateNotification.text')) {
      text = get(this.eventDefinition,'ui.reValidateNotification.text');
      text = this.interpolateService.interpolate(text, this.selectedEvent);
    }
    else {
      let updatedDate = get(this.selectedEvent, 'meta.lastUpdated');
      updatedDate = moment(updatedDate).format('DD MMM YYYY');
      text = `Event updated on ${updatedDate}. Re-validate event.`;
    }
    return text;
  }
}
